{
  "de": {
    "baseChip": {
      "states": {
        "included": "eingeschlossen",
        "excluded": "ausgeschlossen"
      },
      "sortHint": "Mit den Pfeiltasten verschieben"
    }
  }
}
